import React from 'react';
import TaskCardItem from './TaskCardItem';

const TaskCardItems = ({
  allowDatasetLink,
  allowRequestLink,
  canEdit,
  category,
  email,
  items,
}) => (items.map((item, index) => (
  <TaskCardItem
    canEdit={canEdit}
    category={category}
    email={email}
    key={`tasks_card_item_${item.id}`}
    task={item}
    upward={index > 4}
    allowRequestLink={allowRequestLink}
    allowDatasetLink={allowDatasetLink}
  />
)));

export default TaskCardItems;
